import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';

const namespace = 'features.settings.price_lists.index';

function ActionButtons({ priceList, onArchive, onUnarchive, onDuplicate }) {
  return (
    <span>
      <button
        type="button"
        className="qmb-control--icon"
        title={translate('duplicate', { namespace })}
        aria-label={translate('duplicate', { namespace })}
        onClick={onDuplicate}>
        <i className="fa-light fa-copy" />
      </button>
      {priceList.active ? (
        <button
          type="button"
          className="qmb-control--icon"
          onClick={onArchive}
          title={translate('archive', { namespace })}
          aria-label={translate('archive', { namespace })}>
          <i className="fa-light fa-box-archive" />
        </button>
      ) : (
        <button
          type="button"
          className="qmb-control--icon"
          onClick={onUnarchive}
          title={translate('restore', { namespace })}
          aria-label={translate('restore', { namespace })}>
          <i className="fa-light fa-rotate-left" />
        </button>
      )}
    </span>
  );
}

ActionButtons.propTypes = {
  priceList: PropTypes.object.isRequired,
  onArchive: PropTypes.func.isRequired,
  onUnarchive: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired
};

export default ActionButtons;
